import React from 'react';
import AsyncSelect from 'react-select/async';
import { useController, Control } from 'react-hook-form';
import styles from '../styled-select.module.scss';
import { styleBase, styleBold } from '../style';

type OptionType = {
  value: string
  label: string | null
};

interface SelectProps {
  name: string,
  control: Control<any>,
  rules?: any,
  widthLabel?: string | null,
  inline?: boolean,
  placeholder?: string,
  isMulti?: boolean,
  endpoint: string,
  label?: string | null,
  className?: string,
  handleChange?: (val: any) => void,
  prop?: any,
}

const AsyncStyledSelect = ({
  name,
  control,
  rules,
  endpoint,
  widthLabel = null,
  inline = false,
  isMulti = false,
  placeholder = '',
  label = null,
  className,
  handleChange,
  ...props
}: SelectProps) => {
  // const [inputValue, setInputValue] = useState('');

  const { field } = useController({
    name,
    control,
    rules,
  });

  const promiseOptions = (search?: string) => new Promise<any>((resolve, reject) => {
    const config = {
      method: 'GET',
      headers: {
        Authorization: `${localStorage.getItem('token')}`,
      },
    };

    let url = `${process.env.REACT_APP_API_URL}${endpoint}`;
    if (search) url += `?search=${encodeURIComponent(search)}`;
    fetch(url, config).then(async (response) => {
      const options = (await response.json())?.options || [];
      resolve(options);
    }).catch((error) => {
      console.log(error);
      reject(error);
    });
  });

  const loadOptions = (
    inputValue: string,
    callback: (options: OptionType[]) => void,
  ) => {
    const get = async () => {
      try {
        const options = await promiseOptions(inputValue);
        callback(options);
      } catch (error) {
        callback([]);
        console.log(error);
      }
    };
    get();
  };

  return (
    <div className={inline ? `${styles['container-select']} ${styles.inline}` : `${styles['container-select']}`}>
      {label && <label style={widthLabel ? { minWidth: widthLabel } : {}}>{label}</label>}
      <AsyncSelect
        {...field}
        {...props}
        // onInputChange={(v: string) => {
        //   console.log(v);
        // }}
        onChange={(opt: OptionType) => {
          field.onChange(opt?.value);
          if (handleChange) handleChange(opt);
        }}
        loadOptions={loadOptions}
        defaultOptions
        isMulti={isMulti}
        className={`${styles.select}`}
        placeholder={placeholder}
        styles={className === 'bold' ? styleBold : styleBase}
      />
    </div>
  );
};
export default AsyncStyledSelect;
